var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E6F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3809 16.0001L14.7909 18.4201L19.6209 13.5801",
    stroke: "#3B58FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7509 6.45031C15.4409 5.86031 16.5709 5.86031 17.2709 6.45031L18.8509 7.81031C19.1509 8.07031 19.7109 8.28031 20.1109 8.28031H21.8109C22.8709 8.28031 23.7409 9.15031 23.7409 10.2103V11.9103C23.7409 12.3003 23.9509 12.8703 24.2109 13.1703L25.5709 14.7503C26.1609 15.4403 26.1609 16.5703 25.5709 17.2703L24.2109 18.8503C23.9509 19.1503 23.7409 19.7103 23.7409 20.1103V21.8103C23.7409 22.8703 22.8709 23.7403 21.8109 23.7403H20.1109C19.7209 23.7403 19.1509 23.9503 18.8509 24.2103L17.2709 25.5703C16.5809 26.1603 15.4509 26.1603 14.7509 25.5703L13.1709 24.2103C12.8709 23.9503 12.3109 23.7403 11.9109 23.7403H10.1809C9.12086 23.7403 8.25086 22.8703 8.25086 21.8103V20.1003C8.25086 19.7103 8.04086 19.1503 7.79086 18.8503L6.44086 17.2603C5.86086 16.5703 5.86086 15.4503 6.44086 14.7603L7.79086 13.1703C8.04086 12.8703 8.25086 12.3103 8.25086 11.9203V10.2003C8.25086 9.14031 9.12086 8.27031 10.1809 8.27031H11.9109C12.3009 8.27031 12.8709 8.06031 13.1709 7.80031L14.7509 6.45031Z",
    stroke: "#3B58FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/sales-icon.0b38fc1942fb0b6e7328a71071aaf325.svg";
export { ForwardRef as ReactComponent };